import { create } from "zustand";

const DEV_MODE_STORAGE_KEY = "june_dev_mode_enabled";
const PERSONA_STORAGE_KEY = "june_active_persona";

export const useStore = create((set) => ({
  uid: null,
  userLoading: true,
  token: null,
  user: null,
  company: {
    id: null,
    name: "",
    domain: "",
    ats_integration_id: null,
  },
  onboardingRequired: false,
  logoutReason: null,
  role: null,

  /** Developer mode (only relevant in dev environment; persisted in localStorage) */
  devModeEnabled: typeof window !== "undefined" ? localStorage.getItem(DEV_MODE_STORAGE_KEY) === "true" : false,
  setDevModeEnabled: (value) => {
    if (typeof window !== "undefined") {
      localStorage.setItem(DEV_MODE_STORAGE_KEY, value ? "true" : "false");
    }
    set({ devModeEnabled: value });
  },

  /** Active persona for dev-only view switching: 'employer' | 'candidate' */
  activePersona: typeof window !== "undefined"
    ? (localStorage.getItem(PERSONA_STORAGE_KEY) || "employer")
    : "employer",
  setActivePersona: (persona) => {
    if (typeof window !== "undefined") {
      localStorage.setItem(PERSONA_STORAGE_KEY, persona);
    }
    set({ activePersona: persona });
  },

  /** Authentication */
  setUid: (newUid) => set({ uid: newUid }),
  setToken: (token) => set({ token }),
  setUser: (user) => set({ user }),
  setCompany: (newCompany) => set({ company: newCompany }),
  setOnboardingRequired: (required) => set({ onboardingRequired: required }),
  setUserLoading: (loading) => set({ userLoading: loading }),
  setRole: (role) => set({ role }),
  setLogoutReason: (reason) => set({ logoutReason: reason }),

  setLogout: () => set({
    uid: null,
    token: null,
    user: null,
    company: null,
    role: null,
    logoutReason: null,
    applicantSearchCache: null
  }),

  /** Job Profile */
  jobs: [],
  setJobs: (jobs) => set({ jobs }),

  /** Applicant Search Cache */
  applicantSearchCache: null,
  setApplicantSearchCache: (cache) => set({ applicantSearchCache: cache }),
  clearApplicantSearchCache: () => set({ applicantSearchCache: null }),
}));
